import React from 'react';
import { connect } from 'react-redux';
import {
  Button,
  Modal,
  ButtonGroup,
  Spinner,
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faSave,
  faHome,
  faPrescriptionBottleAlt,
  faFileInvoiceDollar,
  faBorderStyle,
  faArrowCircleDown,
} from '@fortawesome/pro-duotone-svg-icons';
import { faTimes } from '@fortawesome/pro-light-svg-icons';
import Control from './Control';
import EntryPage from './page-specific/entry-page';
import Affordability from './page-specific/affordability-page';
import DrugsAndDosages from './site-wide/drugs-and-dosages';
import Styling from './site-wide/styling';
import Footer from './site-wide/footer';

import { saveSiteTheme } from '../../../actions/sites';

class EditSiteModal extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      error: false,
    };
  }

  close = () => {
    const { dispatch } = this.props;
    dispatch({ type: 'CLOSE_MODAL', modal: 'editSiteOpen' });
  };

  handleSave = () => {
    const { selectedFormularySite, values } = this.props;
    saveSiteTheme(selectedFormularySite, values)
      .then(() => {
        this.close();
      })
      .catch(() => {
        this.setState({ error: true });
      });
  };

  /* unused
  handleTabChange = ({ target }) => {
    const { dispatch } = this.props;
    dispatch({ type: 'CHANGE_SITE_TAB', tab: target.id });
  };
  */

  handleSiteWideTabChange = ({ target }) => {
    const { dispatch } = this.props;
    dispatch({ type: 'CHANGE_SITE_WIDE_TAB', tab: target.id });
  };

  handlePageSpecificTabChange = ({ target }) => {
    const { dispatch } = this.props;
    dispatch({ type: 'CHANGE_PAGE_SPECIFIC_TAB', tab: target.id });
  };

  handleConfigChange = ({ target }) => {
    const { dispatch } = this.props;
    dispatch({ type: 'CHANGE_SITE_CONFIG', config: target.id });
  };

  render() {
    const {
      isOpen,
      siteConfig,
      siteWideTab,
      pageSpecificTab,
      saving,
      selectedFormularySite,
    } = this.props;
    const { error } = this.state;

    return (
      <Modal
        isOpen={isOpen}
        toggle={this.close}
        className="mw-100 mx-xl-7 mx-lg-6 mx-4 fade-in"
        zIndex="100000"
      >
        <div
          className="px-5 py-3 h4 mb-0 d-flex justify-content-between align-items-center"
          style={{ borderBottom: '1px solid lightGrey' }}
        >
          <div className="d-flex">
            <div className="me-5 align-self-center">
              Edit Site Configurations
            </div>
            <ButtonGroup>
              <Button
                id="site_wide"
                onClick={this.handleConfigChange}
                color="primary"
                outline={siteConfig !== 'site_wide'}
              >
                Site-Wide
              </Button>
              <Button
                id="page_specific"
                onClick={this.handleConfigChange}
                color="primary"
                outline={siteConfig !== 'page_specific'}
              >
                Page-Specific
              </Button>
            </ButtonGroup>
          </div>
          <Button color="white" onClick={this.close}>
            <FontAwesomeIcon icon={faTimes} size="lg" />
          </Button>
        </div>
        <div className="my-2 px-5 text-right">
          Site URL:&nbsp;
          <span className="font-weight-bold">{selectedFormularySite}</span>
        </div>

        {siteConfig === 'site_wide'
          ? (
            <>
              <div className="py-2 bg-darker d-flex justify-content-around align-items-center">
                <Control id="drugs_and_dosages" icon={faPrescriptionBottleAlt} onClick={this.handleSiteWideTabChange}>
                  Drugs & Dosages
                </Control>
                <Control id="styling" icon={faBorderStyle} onClick={this.handleSiteWideTabChange}>
                  Styling
                </Control>
                <Control id="footer" icon={faArrowCircleDown} onClick={this.handleSiteWideTabChange}>
                  Footer
                </Control>
              </div>

              <div>
                {siteWideTab === 'drugs_and_dosages' && (
                  <DrugsAndDosages />
                )}
                {siteWideTab === 'styling' && (
                  <Styling />
                )}
                {siteWideTab === 'footer' && (
                  <Footer />
                )}
              </div>
            </>
          ) : (
            <>
              <div className="py-2 bg-darker d-flex justify-content-around align-items-center">
                <Control id="entry_page" icon={faHome} onClick={this.handlePageSpecificTabChange}>
                  Entry Page
                </Control>
                <Control id="affordability" icon={faFileInvoiceDollar} onClick={this.handlePageSpecificTabChange}>
                  Affordability Page
                </Control>
              </div>

              <div>
                {pageSpecificTab === 'entry_page' && (
                  <EntryPage />
                )}
                {pageSpecificTab === 'affordability' && (
                  <Affordability />
                )}
              </div>
            </>
          )}

        <div className="px-5 pt-1 pb-5 justify-content-start d-flex align-items-center">
          <Button
            color="primary"
            className="me-3 text-white px-4"
            onClick={this.handleSave}
            disabled={saving}
          >
            <FontAwesomeIcon icon={faSave} size="lg" className="me-2" />
            Publish
            {saving && (
              <Spinner size="sm" className="ms-2" />
            )}
          </Button>
          <Button
            color="dark"
            outline
            className="px-4"
            onClick={this.close}
            disabled={saving}
          >
            <FontAwesomeIcon icon={faTimes} size="lg" className="me-2" />
            Cancel
          </Button>
          {error ? <div className="text-danger ms-3">Something went wrong.</div> : null}
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = (store) => ({
  isOpen: store.modals.editSiteOpen,
  siteWideTab: store.modals.siteWideTab,
  siteConfig: store.modals.siteConfig,
  pageSpecificTab: store.modals.pageSpecificTab,
  selectedFormularySite: store.sites.selectedFormularySite,
  values: store.sites.values,
  saving: store.sites.saving,
});

export default connect(mapStateToProps)(EditSiteModal);
